import observeStore from './observeStore';
import scoringSelector from 'selectors/scoringSelector';

export default function scoringObserver(store) {
    return observeStore(store, scoringSelector, (currentScoring = {}, nextScoring) => {
        const { complete: prevScoringComplete = false } = currentScoring;
        const { complete: currentScoringComplete = false } = nextScoring;
        if (currentScoringComplete === true && prevScoringComplete === false) {
            if (document) {
                document.body.classList.remove('watch-loading');
            }
        }
    });
}



// WEBPACK FOOTER //
// ./app/lib/observe/scoringObserver.js